// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__31mBb","size-sm":"Modal_size-sm__2gzmE","size-md":"Modal_size-md__3nrId","size-lg":"Modal_size-lg__3zQXt"};